import { heroData } from '@/mocks/homeData';

export default function Hero() {
  return (
    <section
      id="hero"
      className="relative min-h-[600px] md:min-h-[700px] flex items-center pt-[72px] overflow-hidden"
    >
      <div className="absolute inset-0 bg-background-50">
        <img
          src="https://readdy.ai/api/search-image?query=Abstract%20dramatic%20composition%20with%20warm%20red%20coral%20and%20amber%20gradient%2C%20Chinese%20social%20media%20news%20aesthetic%2C%20floating%20geometric%20shapes%20suggesting%20information%20fragments%2C%20trending%20topics%20visualization%2C%20bold%20graphic%20design%20style%2C%20clean%20modern%20atmosphere%2C%20editorial%20quality%2C%20no%20text&width=1920&height=1080&seq=hero-bg&orientation=landscape"
          alt="51今日大瓜热门爆料背景"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/25 to-black/50"></div>
      </div>

      <div className="relative w-full px-4 md:px-6 z-10">
        <div className="w-full flex flex-col lg:flex-row items-center gap-8 md:gap-12 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <span className="inline-block px-4 py-1.5 rounded-full bg-primary-500/20 text-primary-300 text-sm font-medium mb-4 whitespace-nowrap">
              {heroData.tag}
            </span>

            <h1 className="font-heading text-3xl md:text-4xl lg:text-5xl text-background-50 leading-tight mb-3">
              {heroData.title}
            </h1>

            <p className="text-lg md:text-xl text-primary-200 font-medium mb-6">
              {heroData.slogan}
            </p>

            <p className="text-sm md:text-base text-background-200/90 leading-relaxed mb-8 max-w-2xl mx-auto lg:mx-0">
              {heroData.summary}
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-6 mb-8">
              {heroData.stats.map((stat) => (
                <div key={stat.label} className="text-center">
                  <div className="text-2xl md:text-3xl font-bold text-accent-400 font-heading">
                    {stat.value}
                  </div>
                  <div className="text-xs text-background-300 mt-1 whitespace-nowrap">
                    {stat.label}
                  </div>
                </div>
              ))}
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href="#ranking"
                className="inline-flex items-center gap-2 px-6 py-3 bg-primary-500 hover:bg-primary-600 text-background-50 font-medium rounded-md transition-colors whitespace-nowrap cursor-pointer"
              >
                <i className="ri-fire-line"></i>
                查看今日大瓜排行榜
              </a>
              <a
                href="#index"
                className="inline-flex items-center gap-2 px-6 py-3 bg-background-50/15 hover:bg-background-50/25 text-background-50 font-medium rounded-md border border-background-50/30 transition-colors whitespace-nowrap cursor-pointer"
              >
                <i className="ri-compass-3-line"></i>
                浏览热门大瓜合集
              </a>
            </div>
          </div>

          <div className="flex-1 w-full hidden lg:block">
            <div className="relative">
              <img
                src="https://readdy.ai/api/search-image?query=Modern%20editorial%20news%20aggregation%20dashboard%20concept%2C%20floating%20cards%20with%20trending%20topics%2C%20warm%20coral%20and%20amber%20color%20scheme%2C%20clean%20minimal%20design%2C%20information%20visualization%2C%20Chinese%20social%20media%20aesthetic%2C%20professional%20layout%2C%20sophisticated%20UI%20concept&width=800&height=600&seq=hero-visual&orientation=landscape"
                alt="51今日大瓜热门爆料聚合平台"
                className="w-full h-auto rounded-lg"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}